import { render, staticRenderFns } from "./MoveToStepPopUp.vue?vue&type=template&id=ff6bc910&scoped=true&lang=pug"
import script from "./MoveToStepPopUp.vue?vue&type=script&lang=ts"
export * from "./MoveToStepPopUp.vue?vue&type=script&lang=ts"
import style0 from "./MoveToStepPopUp.vue?vue&type=style&index=0&id=ff6bc910&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6bc910",
  null
  
)

/* custom blocks */
import block0 from "./MoveToStepPopup.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fcomponents%2FPopups%2FMoveToStepPopUp.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports